import { Dispatch, SetStateAction } from 'react'
import { useNavigate } from 'react-router-dom'
import ModalContainer from 'components/ModalContainer'
import modalImage from 'assets/images/physical-card-modal.png'
import { useLimitPhysicalCardStore } from 'store'
import { toLocaleCurrency } from 'utils/dinero'
import PrimaryButton from 'components/primaryButton'

interface MinBalanceModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

const MinBalanceModal = ({ isOpen, setIsOpen }: MinBalanceModalProps) => {
  const { minBalance } = useLimitPhysicalCardStore()

  const navigate = useNavigate()

  return (
    <ModalContainer isShown={isOpen} setModalFunction={setIsOpen}>
      <div className='text-center'>
        <h4 className='font-bold text-2xl mt-8 px-2'>
          ¡Estás a un paso de tener tu tarjeta!
        </h4>
        <img className='w-56 h-56 mx-auto -my-2' src={modalImage} alt='' />
        <p>
          Ingresá desde ${toLocaleCurrency(minBalance)} en tu billetera y obtené
          tu tarjeta física ¡sin cargo!
        </p>
        <PrimaryButton
          className='mt-4'
          primaryButtonFunction={() => navigate('/cargar-dinero')}
          buttonText='Ingresar dinero'
        />
      </div>
    </ModalContainer>
  )
}

export default MinBalanceModal
